import { render } from "./EmptyCart.vue?vue&type=template&id=585d359c"
import script from "./EmptyCart.vue?vue&type=script&lang=js"
export * from "./EmptyCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/static/EmptyCart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "585d359c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('585d359c', __exports__)) {
    api.reload('585d359c', __exports__)
  }
  
  module.hot.accept("./EmptyCart.vue?vue&type=template&id=585d359c", () => {
    api.rerender('585d359c', render)
  })

}


export default __exports__